exports = module.exports = require("/code/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".stamp-Fade{position:absolute;left:0;z-index:203;display:none;width:100%;height:100vh;-webkit-transition:none;transition:none;-webkit-transform:translate(0,0);transform:translate(0,0);will-change:transform,opacity}.stamp-Fade[data-animate=true]{-webkit-transition:opacity .1s linear;transition:opacity .1s linear}@media only screen and (min-width:62em){.stamp-Fade{display:block}}.stamp-Fade--top{-webkit-transform:translate(0,-100%);transform:translate(0,-100%)}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** /code/~/css-loader?-minimize!/code/~/postcss-loader!/code/~/less-loader!./stamp/Fade.less
 ** module id = 321
 ** module chunks = 1 2
 **/